export const routes = {
  login: () => "/login",
  home: () => "/",
};
